@if (mapService.loadedMap) {
  <google-map
    #map
    [height]="'100%'"
    [width]="'100%'"
    [center]="{ lat: centerpoint.lat, lng: centerpoint.lng }"
    [zoom]="zoom"
    [options]="mapOptions">
    @for (shop of shops; track shop.id) {
      <div>
        @if (shop.showOnMap) {
          <div
            appMapOverlay
            [position]="{ lat: +shop.location.latitude, lng: +shop.location.longitude }"
            [onTop]="shop.showOnMap"
            [panToOpen]="true">
            <div class="row pr-4 m-0">
              <div class="left col-4 p-0">
                @if (
                  shopFilterService.filterBy(
                    [shop],
                    shopFilterService.distance(),
                    shopFilterService.activeFilters()
                  ).length < 1
                ) {
                  <div class="isFiltered">{{ 'ALPY_MAP.doesntMeetFilter' | alpitranslate }}</div>
                }
                <img
                  data-test="shopImage"
                  [class.c-pointer]="mapType === 'town'"
                  (click)="clickedInfoBox($event, shop)"
                  src="{{ shop.imagePath | platformurl }}"
                  alt="{{ shop.name }}"
                  class="shop-image" />
              </div>
              <div
                data-test="closeMapDetailButton"
                class="close-button-map-detail d-flex align-items-center justify-content-center"
                (click)="$event.stopPropagation(); shop.showOnMap = false">
                <app-icon name="cross" />
              </div>
              <div class="alpin-right col-8 p-0 pl-1 py-2 m-0">
                <!-- google-map__info-pile-right -->
                @if (mapType === 'town') {
                  <a href="#" (click)="clickedInfoBox($event, shop)">
                    {{ shop.name }}
                  </a>
                } @else {
                  <strong>
                    {{ shop.name }}
                  </strong>
                }
                <p data-test="shopAddress" class="address m-0 pt-1">
                  {{
                    shop.isVirtualShop
                      ? ('ALPY_MAP.virtualAddress'
                        | alpitranslate: { shopname: shop.name, placename: shop.townName })
                      : shop.address
                  }}
                </p>
              </div>

              @if (
                shop.unbookableReasonsFor(
                  bookingParameters.start,
                  bookingParameters.end,
                  bookingParameters.ages
                ).length && bookingParameters.userDefinedSearch
              ) {
                <div>
                  <app-unbookable-info
                    [reason]="shop.primaryUnbookableReasonFor(bookingParameters.start, bookingParameters.end)"
                    [map]="true">
                  </app-unbookable-info>
                </div>
              } @else {
                @if (shop.hotelDistance) {
                  @defer (when shop.hotelDistance) {
                    <div class="distance-hint px-2 py-1">
                      <app-distance-display
                        [distanceMeter]="shop.hotelDistance.distanceMeters"
                        [distanceSeconds]="shop.hotelDistance.distanceSeconds"
                        [distanceMeterCar]="shop.hotelDistance.distanceMetersCar"
                        [distanceSecondsCar]="shop.hotelDistance.distanceSecondsCar"
                        [type]="shop.shopType" />
                    </div>
                  }
                }
                @if (mapType === 'town') {
                  <p data-test="shopPrice" class="price important-label">
                    {{
                      shop.defaultProductOnlinePriceRaw
                        | alpicurrency: currencyService.getActualCurrency() : true
                    }}
                  </p>
                }
              }

              @if (
                shop.unbookableReasonsFor(
                  bookingParameters.start,
                  bookingParameters.end,
                  bookingParameters.ages
                ).length === 0 && mapType === 'town'
              ) {
                <div class="col-12 px-2 py-1">
                  <div class="price-wrapper">
                    @if (!shop.usesAgeIntervalLength || children.length < 1) {
                      <div>
                        <div class="d-flex flex-wrap">
                          <!-- package text for number adults, number kids -->
                          <div class="flex-shrink-0">
                            @if (ages.length > 0 && children.length === 0) {
                              <strong>
                                {{ 'ALPY_MAP.priceInfo' | alpitranslate: { number_adults: adults.length } }}
                              </strong>
                            }
                            @if (ages.length > 0 && children.length > 0) {
                              <strong>
                                {{
                                  'ALPY_MAP.priceInfoWithChildren'
                                    | alpitranslate
                                      : { number_adults: adults.length, number_children: children.length }
                                }}
                              </strong>
                            }
                          </div>
                          <!-- icons -->
                          <div class="flex-shrink-0 pl-1">
                            @if (ages.length) {
                              <span class="product__additionals__hide-mobile container-people-icons">
                                @if (ages.length < 12) {
                                  @for (age of ages; track age) {
                                    <app-icon name="user" [style.font-size]="age < 18 ? '10px' : ''" />
                                  }
                                }
                              </span>
                            }
                          </div>
                        </div>
                        <span class="date-wrapper d-flex align-items-center">
                          <app-icon name="clock" class="mr-1" />
                          <strong
                            >{{ bookingParameters.start | date: ('ALPY_MAP.fromDateFormat' | alpitranslate) }}
                            -
                            {{
                              bookingParameters.end | date: ('ALPY_MAP.toDateFormat' | alpitranslate)
                            }}</strong
                          >
                        </span>
                        <br />
                        @if (
                          shop.unbookableReasonsFor(
                            bookingParameters.start,
                            bookingParameters.end,
                            bookingParameters.ages
                          ).length
                        ) {
                          <div>
                            <div class="unbookable-shop-info">
                              <app-icon name="infoCircle" class="mr-1" />
                              {{
                                'ALPY_MAP.unbookableInfoBeforeSeason'
                                  | alpitranslate
                                    : {
                                        season_start:
                                          shop.seasonFromDate
                                          | date: ('ALPY_MAP.fromDateFormat' | alpitranslate)
                                      }
                              }}
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        } @else {
          @if (getFilteredSignal(shop)()) {
            <div
              appMapOverlay
              [position]="{ lat: +shop.location.latitude, lng: +shop.location.longitude }"
              [onTop]="shop.showOnMap"
              [filtered]="true">
              <div
                data-test="shopIconInfoClosed"
                class="price price-closed"
                (click)="$event.stopPropagation(); toggleDetails(shop)">
                @if (shop.unbookable_reasons.length) {
                  <app-icon name="stop" class="mx-2" />
                } @else {
                  {{
                    shop.defaultProductOnlinePriceRaw
                      | alpicurrency: currencyService.getActualCurrency() : true
                  }}
                }
              </div>
            </div>
          } @else {
            <div
              appMapOverlay
              [position]="{ lat: +shop.location.latitude, lng: +shop.location.longitude }"
              [onTop]="shop.showOnMap">
              <div
                data-test="shopIconInfoClosed"
                class="price price-closed"
                (click)="$event.stopPropagation(); toggleDetails(shop)">
                @if (shop.unbookable_reasons.length) {
                  <app-icon name="stop" class="mx-2" />
                }
                @if (shop.unbookable_reasons.length === 0) {
                  {{
                    shop.defaultProductOnlinePriceRaw
                      | alpicurrency: currencyService.getActualCurrency() : true
                  }}
                }
              </div>
            </div>
          }
        }
      </div>
    }
    @if (selectedHotelService.selectedHotel()) {
      <div
        appMapOverlay
        [wrapperClass]="'hotel'"
        [position]="{
          lat: +selectedHotelService.selectedHotel().geometry.location.lat(),
          lng: +selectedHotelService.selectedHotel().geometry.location.lng()
        }">
        <div data-test="hotelInfo" class="price price-closed">
          <app-icon name="hotelPin" />
          {{ selectedHotelService.selectedHotel().name }}
        </div>
      </div>
    }
  </google-map>
}
